"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useInlineDrawer_unstable", {
    enumerable: true,
    get: function() {
        return useInlineDrawer_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _reactmotionpreview = require("@fluentui/react-motion-preview");
const _useDrawerDefaultProps = require("../../shared/useDrawerDefaultProps");
const useInlineDrawer_unstable = (props, ref)=>{
    const { size, position, open } = (0, _useDrawerDefaultProps.useDrawerDefaultProps)(props);
    const { separator = false } = props;
    const motion = (0, _reactmotionpreview.useMotion)(open);
    return {
        components: {
            root: 'div'
        },
        root: _reactutilities.slot.always((0, _reactutilities.getIntrinsicElementProps)('div', {
            ...props,
            ref: (0, _reactutilities.useMergedRefs)(ref, motion.ref)
        }), {
            elementType: 'div'
        }),
        size,
        position,
        separator,
        motion
    };
};
